import { useTour } from '@reactour/tour';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { toastSuccess } from 'ui/partials/Toast';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import partialConstants from 'ui/partials/utils/constants';

import contactsConstants from '../../contact/utils/constants';
import c from '../utils/constants';
import { TASK_FORM } from '../forms/schema';

export default function useCreateTask(params = {}) {
  const queryClient = useQueryClient();
  const { state } = useProvider();
  const { accountId, accountUserId } = useAdminParams();
  const { isOpen, setIsOpen } = useTour();
  const args = state;

  return useMutation({
    mutationFn: async (payload: TASK_FORM) => {
      if (isOpen) return setIsOpen(false);

      const api = new Api(args);

      const data = await api.post(
        await withAcl({
          account: {
            url: '/api/v1/tasks/',
            payload,
          },
          admin: {
            url: `/api/v2/accounts/${accountId}/users/${accountUserId}/tasks/`,
            payload,
          },
        }),
      );

      return data;
    },
    onSuccess: (successData) => {
      const { data } = successData ?? {};

      queryClient.invalidateQueries({ queryKey: [c.TASKS, params] });

      queryClient.invalidateQueries({ queryKey: [c.TASKS, c.TaskFilter] });
      queryClient.invalidateQueries({ queryKey: [c.LOGS, data?.dealId] });
      queryClient.invalidateQueries({
        queryKey: [contactsConstants.LEADS],
      });
      queryClient.invalidateQueries({
        queryKey: [partialConstants.TAGS],
      });

      toastSuccess('Successfully created new task.');
    },
  });
}
